import { render, staticRenderFns } from "./ImportsAndExportsDialog.vue?vue&type=template&id=70453c9e&scoped=true&"
import script from "./ImportsAndExportsDialog.vue?vue&type=script&lang=js&"
export * from "./ImportsAndExportsDialog.vue?vue&type=script&lang=js&"
import style0 from "./ImportsAndExportsDialog.vue?vue&type=style&index=0&id=70453c9e&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70453c9e",
  null
  
)

export default component.exports